"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
/**
 * Privacy lightbox
 *
 * @namespace
 * @memberOf txGs1Base
 * @public
 */
const _main_1 = require("./_main");
_main_1.txGs1Base.privacy = {
    effect: $(this).closest('.fancybox-wrap').length === 0 ? 'elastic' : 'none',
    tpl: {
        closeBtn: '<button class="fancybox-item fancybox-close close"><span aria-hidden="true">×</span><span class="sr-only">' + _main_1.txGs1Base.language.getLabel('close') + '</span></button>',
        wrap: '<div id="fancybox_privacy" class="fancybox-wrap" tabIndex="-1">' +
            '	<div class="fancybox-skin">' +
            '		<div class="fancybox-outer">' +
            '			<div class="fancybox-inner"></div>' +
            '		</div>' +
            '	</div>' +
            '</div>',
    },
    initialize: function () {
        'use strict';
        $('[data-privacy-popup]').on('click.txGs1Base', function (event) {
            event.preventDefault();
            var videoUrl = $(this).attr('data-youtube-url');
            var playerId = $(this).attr('data-player-id');
            if ($.cookie('gs1_activate_all_videos') === '1') {
                _main_1.txGs1Base.privacy.youtubeLightbox(this, videoUrl, playerId);
            }
            else {
                _main_1.txGs1Base.privacy.privacyLightbox(this, videoUrl, playerId);
            }
        });
    },
    privacyLightbox: function (orig, videoUrl, playerId) {
        var lightboxHtml = $('<div class="toolkit fancybox-privacy" data-youtube-url="' + videoUrl + '" data-player-id="' + playerId + '">' +
            '	<div class="fancybox-main grid-col">' + // adding "main" class for styling purposes
            '			<h3>' + _main_1.txGs1Base.language.getLabel('privacy_headline') + '</h3>' +
            '			' + _main_1.txGs1Base.language.getLabel('privacy_info_youtube') +
            '			<button class="btn btn-primary" data-privacy-youtube-yes>' +
            '       <span class="btntxt"><span class="icon" aria-hidden="true"></span>' +
            _main_1.txGs1Base.language.getLabel('privacy_button_youtube_yes') +
            '       </span>' +
            '			</button>' +
            '			<button class="btn btn-secondary" data-privacy-youtube-no>' +
            '       <span class="btntxt"><span class="icon" aria-hidden="true"></span>' +
            _main_1.txGs1Base.language.getLabel('privacy_button_youtube_no') +
            '       </span>' +
            '			</button>' +
            '			<div class="checkbox-wrapper">' +
            '				<input type="checkbox" id="youtube_cookie" value="1" name="youtube-cookie" />' +
            '				<label class="checkbox" for="youtube_cookie">' +
            _main_1.txGs1Base.language.getLabel('privacy_cookie_youtube') +
            '</label>' +
            '			</div>' +
            '	</div>' +
            '</div>');
        $.fancybox(lightboxHtml, {
            autoSize: true,
            orig: orig,
            openEffect: _main_1.txGs1Base.privacy.effect,
            closeEffect: 'fade',
            tpl: _main_1.txGs1Base.privacy.tpl,
            helpers: {
                overlay: {
                    locked: false
                }
            },
            afterShow: function () {
                $('[data-privacy-youtube-yes]').on('click.txGs1Base', function (event) {
                    event.preventDefault();
                    if ($('#youtube_cookie').prop('checked') === true) {
                        // Set cookie
                        $.cookie('gs1_activate_all_videos', 1, {
                            expires: 365
                        });
                    }
                    var $privacyEl = $(this).closest('[data-youtube-url]');
                    var videoUrl = $privacyEl.attr('data-youtube-url');
                    var newLightboxHtml = '<figure class="responsive-video youtube">' +
                        '	<iframe id="' + playerId + '" src="' + videoUrl + '" frameborder="0" allowfullscreen></iframe>' +
                        '</figure>';
                    $('.fancybox-inner').html(newLightboxHtml);
                    $.fancybox.update();
                });
                $('[data-privacy-youtube-no]').on('click.txGs1Base', function (event) {
                    event.preventDefault();
                    $.fancybox.close();
                });
            }
        });
    },
    youtubeLightbox: function (orig, videoUrl, playerId) {
        var lightboxHtml = '<figure class="responsive-video youtube">' +
            '	<iframe id="' + playerId + '" src="' + videoUrl + '" frameborder="0" allowfullscreen></iframe>' +
            '</figure>';
        $.fancybox(lightboxHtml, {
            autoSize: true,
            padding: 0,
            orig: orig,
            openEffect: _main_1.txGs1Base.privacy.effect,
            closeEffect: 'fade',
            tpl: _main_1.txGs1Base.privacy.tpl,
            helpers: {
                overlay: {
                    locked: false
                }
            }
        });
    }
};
exports.default = {};
